import {
  deleteCacheDBValueByKey,
  getAllCacheDBValuesForCurrentUser,
} from './indexedDB.cache.utils';
import { CACHE_DB } from '../constants/indexedDB.constants';

const {
  OBJECT_STORES: { DETAIL_FORM_MODELS, ENTITY_DEFINITIONS },
  KEY_PATHS: { FORM_KEY, FORM_ENTITY_KEY },
} = CACHE_DB;

export const handleExpiredCacheForStore = async (store, uiCacheObject, storeName, keyPath) => {
  for (const cacheObj of store) {
    const key = cacheObj[keyPath];
    const uiCacheObjectKey = key.split(' + ')[0];
    const modifiedDate = uiCacheObject[uiCacheObjectKey];

    if (modifiedDate !== cacheObj.modifiedDate) {
      await deleteCacheDBValueByKey(storeName, key);
    }
  }
};

const handleExpiredCache = async ({ entitySchema, forms }) => {
  const [detailFormModels, entityDefinitions] = await Promise.all([
    getAllCacheDBValuesForCurrentUser(DETAIL_FORM_MODELS, FORM_KEY),
    getAllCacheDBValuesForCurrentUser(ENTITY_DEFINITIONS, FORM_ENTITY_KEY),
  ]);

  await handleExpiredCacheForStore(detailFormModels, forms, DETAIL_FORM_MODELS, FORM_KEY);
  await handleExpiredCacheForStore(
    entityDefinitions,
    entitySchema,
    ENTITY_DEFINITIONS,
    FORM_ENTITY_KEY
  );
};

export const handleGetUICacheObjectsResponse = ({ UICacheObjects: { EntitySchema, Forms } }) => {
  const uiCacheObjects = {
    entitySchema: {},
    forms: {},
  };

  EntitySchema.forEach(({ EntityName, ModifiedDate }) => {
    uiCacheObjects.entitySchema[EntityName] = ModifiedDate;
  });

  Forms.forEach(({ FormName, ModifiedDate }) => {
    uiCacheObjects.forms[FormName] = ModifiedDate;
  });

  localStorage.setItem('uiCacheObjects', JSON.stringify(uiCacheObjects));

  handleExpiredCache(uiCacheObjects);
};
